import { render, staticRenderFns } from "./SupplierOnboardingSocialNetwork.vue?vue&type=template&id=5655d048&"
import script from "./SupplierOnboardingSocialNetwork.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingSocialNetwork.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOnboardingSocialNetwork.vue?vue&type=style&index=0&id=5655d048&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports